
import { createClient } from '@supabase/supabase-js'
import { Database } from '@/types/database'

const supabaseUrl = "https://pxitouotodcircmvangu.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4aXRvdW90b2RjaXJjbXZhbmd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkwNDU5MjYsImV4cCI6MjA2NDYyMTkyNn0.lvmaEvbWz08G7lj5fQCHMCWr9lwTAU81i2sVCcNkfuc"

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)
